<template>
  <div class="two-photo">
    <div class="photo-wrap">
      <p class="photo-title">Take a photo of the front of your ID</p>
      <img :src="firstImg" alt="" @click="$emit('on-first-click')">
    </div>

    <div class="photo-wrap">
      <p class="photo-title">Take a photo of the back of your ID</p>
      <img :src="secondImg" alt="" @click="$emit('on-second-click')">
    </div>
  </div>
</template>

<script>
  export default {
    name: "TwoPhoto",
    props: {
      firstImg:{
        type: String,
        default: ""
      },

      secondImg:{
        type: String,
        default: ""
      }
    }
  }
</script>

<style lang="scss" scoped>
  .two-photo {
    .photo-wrap {
      display: inline-block;
      margin-bottom: 30px;
      margin-top: 91px;
      margin-right: 50px;
      .photo-title {
        font-family: Nunito-Regular;
        font-size: 14px;
        color: #2E2E2E;
      }
      img {
        width: 256px;
        height: 156px;
        margin-top: 20px;
        border: 1px solid #9dc7f3;
        border-radius: 8px;
      }
    }
  }
</style>